<template>
    <div class="proxy-history">
      <!-- 交易类型筛选 -->
      <van-tabs v-model:active="activeTab" class="transaction-tabs" @change="handleTabChange">
        <van-tab title="已下单" />
        <van-tab title="交易完成" />
        <van-tab title="交易取消" />
        <van-tab title="交易失败" />
      </van-tabs>
      <!-- 交易记录列表 -->
      <div class="order-list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多记录"
            @load="onLoad" 
          >
            <div
              v-for="item in list"
              :key="item.orderId"
              class="order-item"
              @click="viewDetail(item)"
            >
              <div class="order-header">
                <div class="order-info">
                  <span class="order-id">订单号:{{ item.orderNo }}</span>
                  <span class="order-time">{{ item.createdAt }}</span>
                </div>
              </div>
              <div class="order-content">
               
                <div class="order-details">
                    <div class="detail-row">
                    <span class="label">饰品：</span>
                    <van-image :src="item.imageUrl" fit="contain" width="50px"/>
                  </div>
                  <div class="detail-row">
                    <span class="label">：</span>
                    <span class="price" :class="item.amountClass">{{ item.amount }} </span>
                  </div>
                  <div class="detail-row">
                    <span class="label">状态：</span>
                    <span class="value" v-if="item.status==0">已下单</span>
                    <span class="value" v-if="item.status==1">交易完成</span>
                    <span class="value" v-if="item.status==2">交易取消</span>
                    <span class="value" v-if="item.status==3">交易失败</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <!-- 空状态 -->
      <!-- <van-empty
        v-if="!loading && filteredTransactions.length === 0"
        image="search"
        description="暂无交易记录"
      /> -->
      <!-- 详情弹窗 -->
      <van-popup v-model:show="showDetail" position="bottom" :style="{ height: '50%' }" round>
        <div class="detail-popup">
          <div class="detail-header">
            <h3>交易详情</h3>
            <van-icon name="cross" @click="showDetail = false" />
          </div>
          <div v-if="selectedItem" class="detail-content">
            <div class="detail-section">
                <van-cell title="订单号" :value="selectedItem.orderNo" />
              <van-cell title="" :value="selectedItem.amount" />
              <van-cell title="时间" :value="selectedItem.createdAt" />
              <van-cell title="状态"  >
                <template #value>
                    <span class="value" v-if="selectedItem.status==0">已下单</span>
                    <span class="value" v-if="selectedItem.status==1">交易完成</span>
                    <span class="value" v-if="selectedItem.status==2">交易取消</span>
                    <span class="value" v-if="selectedItem.status==3">交易失败</span>
                </template>
              </van-cell>
              <van-cell title="订单凭证"  >
                <template #value>
                    <van-image :src="selectedItem.orderField1" fit="contain" alt="订单凭证" width="50px" height="50px"/>
                </template>
              </van-cell>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </template>
  
  <script>
  import { showToast } from 'vant';
  import request from '@/utils/request'
  export default {
    data() {
      return {
        activeTab: 0, 
        transactions: [],
        list: [],
        loading: false,
        finished: false,
        page: 0,
        pageSize: 10,
        refreshing: false,
        showDetail: false,
        selectedItem: null,
        zijinForm:{}
      };
    },
    created() {
      // this.page = 1
      // this.getList()
    },
    methods: {
      getList(){
        if(this.finished){
          return false
        }
        request.get('/front/weapon/query',{
        params:{
          pageNum:this.page,
          pageSize:10,
          status:this.activeTab,
          categoryName:this.zijinForm.categoryName,
          orderNo:this.zijinForm.orderNo,
        }
      }).then(res => {
          if (res.code == 200) {
            if (this.page === 1) {
              this.list = res.rows;
            } else {
              this.list = [...this.list, ...res.rows];
            }
            // 判断是否还有更多数据
            this.finished = this.list.length >= res.total;
          } else {
            this.finished = true;
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      onLoad() {
        setTimeout(() => {
          this.page++;
          this.getList();
        }, 500);
      },
      onRefresh() {
        this.refreshing = true;
        setTimeout(() => {
          this.list = [];
          this.page = 1;
          this.finished = false;
          this.getList();
          this.refreshing = false;
        }, 500);
      },
      handleTabChange(tabIndex) {
        console.log(tabIndex);
        this.activeTab = tabIndex;
        this.page = 1;
        this.finished = false; // 重置加载完成状态
        this.list = []; // 清空当前列表
        this.getList();
      },
      filterTransactions() {
        if (this.activeTab === 0) {
          this.filteredTransactions = this.transactions;
        } else {
          this.filteredTransactions = this.transactions.filter(item => item.type === this.activeTab);
        }
      },
      viewDetail(item) {
        this.selectedItem = item;
        this.showDetail = true;
      }
    }
  };
  </script>
  
  <style scoped>
  .proxy-history {
    background-color: #f7f8fa;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .order-list {
    padding: 16px;
    overflow-y: scroll;
    min-height: 0;
  }
  .order-item {
    background: white;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
  }
  .order-item:active {
    transform: scale(0.98);
  }
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  .order-info {
    flex: 1;
  }
  .order-id {
    font-size: 14px;
    font-weight: 500;
    color: #323233;
    display: block;
    margin-bottom: 4px;
  }
  .order-time {
    font-size: 12px;
    color: #969799;
  }
  .order-status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
  .status-success {
    color: #07c160;
  }
  .status-failed {
    color: #f53f3f;
  }
  .order-content {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
  }
  .order-avatar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .order-details {
    flex: 1;
  }
  .detail-row {
    display: flex;
    margin-bottom: 6px;
    font-size: 14px;
  }
  .detail-row:last-child {
    margin-bottom: 0;
  }
  .label {
    color: #646566;
    width: 80px;
    flex-shrink: 0;
  }
  .value {
    color: #323233;
    flex: 1;
  }
  .price-row .price {
    color: #ee0a24;
    font-weight: 600;
  }
  /* 详情弹窗样式 */
  .detail-popup {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
  }
  .detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebedf0;
  }
  .detail-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }
  .detail-section {
    margin-bottom: 24px;
  }
  </style>